import request from '@/tool/http'

// export function toArea(data) {
//     return request({
//       url: '/mini/toArea.html',
//       method: 'post',
//       data: data
//     })
// }

// --个人资料
export function getUserInfo() {
  return request({
    url: '/user/toPersonalData.do',
    method: 'post'
  })
}
// --获取用户职称
export function getUserDegree() {
  return request({
    url: '/mini/getUserDegree.do',
    method: 'post'
  })
}
// --获取职称列表
export function getToCode(data) {
  return request({
    url: '/mini/toCode.do',
    method: 'post',
    data: data
  })
}
// --获取区域列表
export function getToArea(data) {
  return request({
    url: '/mini/toArea.do',
    method: 'post',
    data: data
  })
}

// --登录
export function doLogin(data) {
  return request({
    url: '/user/doLogin.do',
    method: 'post',
    data: data
  })
}
// 手机验证码登录
export function doSmsLogin(data) {
    return request({
      url: '/user/doSmsLogin.do',
      method: 'post',
      data: data
    })
}
// 发送验证码
export function toSendMessage(data) {
    return request({
      url: '/user/toSendMessage.html',
      method: 'post',
      data: data
    })
}
// 判断手机号是否注册
export function toOnlyUser(params) {
    return request({
      url: '/user/toOnlyUser.html',
      method: 'get',
      params: params
    })
}
// 忘记密码-修改
export function forgetPassword(data) {
    return request({
      url: '/mini/forgetPassword.html',
      method: 'post',
      data: data
    })
}
// 提交表单，注册账号
export function toDoRegister(data) {
    return request({
      url: '/user/doRegister.html',
      method: 'post',
      data: data
    })
}
// 修改性别/修改头像
export function toDoUpdatePerson(data) {
    return request({
      url: '/user/doUpdatePerson.do',
      method: 'post',
      data: data
    })
}
// 修改联系方式
export function updateContactInfo(data) {
    return request({
      url: '/mini/updateContactInfo.do',
      method: 'post',
      data: data
    })
}
// 修改密码
export function updatePassword(data) {
    return request({
      url: '/mini/updatePassword.do',
      method: 'post',
      data: data
    })
}
// 修改头像时检验图片真实性
export function checkedIdentityByGongAnV4(data) {
    return request({
      url: '/mini/checkedIdentityByGongAnV4.do',
      method: 'post',
      data: data
    })
}
// 修改工作单位
export function toUpdateWorkInfo(data) {
    return request({
      url: '/mini/updateWorkInfo.do',
      method: 'post',
      data: data
    })
}
// 修改专业水平
export function toUpdateMajorAndDegree(data) {
    return request({
      url: '/mini/updateMajorAndDegree.do',
      method: 'post',
      data: data
    })
}
// 获取所在区域
export function toArea(data) {
    return request({
      url: '/mini/toArea.html',
      method: 'post',
      data: data
    })
}
// 修改个人信息
export function doUpdate(data) {
    return request({
      url: '/user/doUpdate.do',
      method: 'post',
      data: data
    })
}